var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9495 17.3425C20.6321 17.3425 22.8067 15.1678 22.8067 12.4853V9.24722C22.8067 6.56469 20.6321 4.39008 17.9495 4.39008C15.267 4.39008 13.0924 6.56469 13.0924 9.24722V12.4853C13.0924 15.1678 15.267 17.3425 17.9495 17.3425ZM17.9495 17.3425C23.3146 17.3425 29.2829 20.7188 29.2829 25.8778V27.0567C29.2829 27.9509 28.558 28.6758 27.6638 28.6758H8.23526C7.34108 28.6758 6.61621 27.9509 6.61621 27.0567V25.8778C6.61621 20.7188 12.5845 17.3425 17.9495 17.3425Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e1295e7aeba3626b3335cd32871d7e70.svg";
export { ForwardRef as ReactComponent };